import { render, staticRenderFns } from "./ShareYourIdeas.vue?vue&type=template&id=f27fd81c&"
import script from "./ShareYourIdeas.vue?vue&type=script&lang=js&"
export * from "./ShareYourIdeas.vue?vue&type=script&lang=js&"
import style0 from "./ShareYourIdeas.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports